/**
 * Application constants: pagination, UI timing, config values
 */

/** Days after soft-delete before the item is permanently removed; must match backend RESTORE_WINDOW_DAYS */
export const RESTORE_WINDOW_DAYS = 7;

export const PAGINATION = {
  DEFAULT_PAGE_SIZE: 10,
  PAGE_SIZE_OPTIONS: [5, 10, 25, 50, 100, 200],
  DASHBOARD_WIDGET_SIZE: 5,
} as const;

export const TABLE_CONFIG = {
  SEARCH_MIN_LENGTH: 2,
  DEBOUNCE_DELAY: 300,
  EMPTY_STATE_MIN_HEIGHT: 200,
} as const;

export const UI_TIMING = {
  TOAST_DURATION: 5000,
  TOOLTIP_DELAY: 500,
  ANIMATION_DURATION: 200,
  DEBOUNCE_DELAY: 300,
  MODAL_TRANSITION: 150,
} as const;
